import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Link, withRouter } from 'react-router-dom'
import './style.scss'
import flagSV from 'images/flag_sv.png'
import flagEN from 'images/flag_en.png'
import classNames from 'classnames'

import {
  fetchLanguage,
  fetchWebTexts,
  toggleMenu,
  pageHistory,
  toggleMyPage
} from 'features/App/duck'

import {
  fetchMenuPages
} from 'features/Pages/duck'

import {
  testLocalstorage,
  checkPathName,
  checkWebshopPathName
} from 'lib/utils'

export class Navigation extends Component {
  constructor(props) {
    super(props)
    this.state = {
      currentPage: '',
      items: []
    }
  }

  generateItems = (lng, menuPages = [], loggedIn = false) => {
    const baseItems = [
      {
        link: '',
        text: lng.Menu.Intro || '',
      },
      {
        link: 'products',
        text: lng.Menu.WebShop || '',
      }
    ]

    // Filter dynamic pages based on authentication and tags
    const dynamicPages = menuPages
      .filter(page => {
        // Check if page requires authentication
        const requiresAuth = page.Tags && page.Tags.includes('inloggad')
        // Only show if user is logged in when required
        return !requiresAuth || loggedIn
      })
      .map(page => ({
        link: page.Slug,
        text: page.Title,
        isDynamic: true
      }))

    const endItems = [
      {
        link: 'kontakt',
        text: lng.Menu.Contact || '',
      },
      {
        link: 'application',
        text: lng.Reseller.Application || '',
      }
    ]

    // Insert dynamic pages between Webshop and Contact
    this.setState({
      items: [...baseItems, ...dynamicPages, ...endItems]
    })
  }

  onChangeLanguage = languageCode => {
    if (testLocalstorage()) {
      localStorage.setItem('language', languageCode)
    }

    this.props.dispatch(this.changeLanguageActions(languageCode))
  }

  changeLanguageActions = languageCode => {
    return dispatch => {
      dispatch(fetchLanguage(languageCode))
      dispatch(fetchWebTexts(languageCode))
      dispatch(fetchMenuPages(languageCode, 'meny'))
    }
  }

  componentDidMount() {
    this.generateItems(this.props.lng, this.props.menuPages, this.props.loggedIn)
    // Fetch menu pages on mount
    this.props.dispatch(fetchMenuPages(this.props.currentLanguage || 'sv', 'meny'))
  }

  componentWillReceiveProps(nextProps) {
    this.generateItems(nextProps.lng, nextProps.menuPages, nextProps.loggedIn)
  }

  componentDidUpdate() {
    let checkedPath = checkPathName(this.props.location.pathname)
    this.props.dispatch(toggleMyPage(checkedPath))
  }

  toggleMenu = () => {
    this.props.dispatch(toggleMenu())
  }

  onNavigate = (pageName) => {
    this.props.dispatch(pageHistory(pageName))
  }
  render() {
    // check if current page starts with link from this.props.history.location.pathname
    const pathname = this.props.location.pathname
    const currentPage = pathname.split('/')[1]

    let isWebshop = checkWebshopPathName(currentPage)

    const links = this.state.items.map(item => (
      <li className={classNames({ active: item.link === 'products' ? isWebshop : item.link === currentPage })} key={item.link}> <Link to={'/' + item.link}>{item.text}</Link></li>
    ))

    return (
      <div className="topmenu">
        <nav className="menu">
          <div className="languages">
            <div onClick={() => this.onChangeLanguage('sv')}><img src={flagSV} alt="Svenska" /></div>
            <div onClick={() => this.onChangeLanguage('en')}><img src={flagEN} alt="Engelska" /></div>
          </div>
          <div className={classNames('containerLinks', { hidden: !this.props.showMenu })}>
            <ul className="links">
              {links}
            </ul>
          </div>
          <div className="hamburger" onClick={this.toggleMenu}>
            <div></div>
            <div></div>
            <div></div>
          </div>
        </nav>
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  lng: state.app.language,
  showMenu: state.app.showMenu,
  currentPage: state.app.currentPage,
  currentLanguage: state.app.currentLanguage,
  menuPages: state.pages.menuPages || [],
  loggedIn: state.user.login.loggedIn
})

export default withRouter(connect(mapStateToProps)(Navigation))
